const INITITAL_STATE = {
  isModalActive: false,
  modalHeader: '',
  reasonCodeFieldName: '',
  commentFieldName: '',
  reason_codes: [],
};

export function ReasonCodeCommentModalReducer(state = INITITAL_STATE, action) {
  switch (action.type) {
    case 'OPEN_REASON_CODE_COMMENT_MODAL': {
      return {
        ...state,
        isModalActive: true
      };
    }

    case 'CLOSE_REASON_CODE_COMMENT_MODAL': {
      return {
        ...state,
        isModalActive: false
      };
    }


    case 'SET_REASON_CODE_COMMENT_FIELDS': {
      const { reasonCodeFieldName, commentFieldName } = action;
      return {
        ...state,
        reasonCodeFieldName,
        commentFieldName
      }
    }


    case 'SET_REASON_CODE_COMMENT_HEADER': {
      const { modalHeader } = action;
      return {
        ...state,
        modalHeader
      }
    }


    case 'SET_REASON_CODE_COMMENT_LIST': {
      const { reason_codes } = action;
      return {
        ...state,
        reason_codes
      }
    }

    default:
      return state;
  }
}  